import { ApolloClient, createHttpLink, from, split } from '@apollo/client';

import { getEnvConfig } from 'config/environment';
import { cache } from 'config/graphql/cache/cache';
import { SUSPENSION_SERVICE } from 'config/graphql/constants';
import { authLink } from 'config/graphql/links/authLink';
import { httpLink, suspensionLink } from 'config/graphql/links/common';
import { errorLink } from 'config/graphql/links/errorLink';
import { suspensionAuthLink } from 'config/graphql/links/suspensionAuthLink';

export const client = new ApolloClient({
  link: split(
    (operation) => operation.getContext().serviceName === SUSPENSION_SERVICE,
    from([suspensionAuthLink, suspensionLink]),
    from([authLink, errorLink, httpLink]),
  ),
  cache,
  connectToDevTools: true,
});

export const meshClient = new ApolloClient({
  link: authLink.concat(
    createHttpLink({
      uri: getEnvConfig().REACT_APP_SUSPENSION_SERVICE_URL,
      headers: { 'x-clubspark-root-provider-id': (window as any).__provider__ },
    }),
  ),
  cache,
  connectToDevTools: true,
});
